import cn from 'classnames';
import React, { useState } from 'react';
import type { Settings, CustomArrowProps } from 'react-slick';
import SlickCarousel from 'react-slick';

import ProgressBar from 'components/complex/Carousel/ProgressBar';

import s from './Carousel.module.scss';

export const PrevArrow: React.FC<CustomArrowProps> = props => {
  return (
    <button type="button" onClick={props.onClick} className={props.className}>
      <svg version="1.1" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
        <path
          d="m28.457 33.793c0.39052 0.39052 0.39052 1.0237 0 1.4142s-1.0237 0.39052-1.4142 0l-14.5-14.5c-0.39052-0.39052-0.39052-1.0237 0-1.4142l14.5-14.5c0.39052-0.39052 1.0237-0.39052 1.4142 0s0.39052 1.0237 0 1.4142l-13.793 13.793 13.793 13.793z"
          fill="currentColor"
        />
      </svg>
    </button>
  );
};

export const NextArrow: React.FC<CustomArrowProps> = props => {
  return (
    <button type="button" onClick={props.onClick} className={props.className}>
      <svg version="1.1" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
        <path
          d="m12.543 33.793c-0.39052 0.39052-0.39052 1.0237 0 1.4142s1.0237 0.39052 1.4142 0l14.5-14.5c0.39052-0.39052 0.39052-1.0237 0-1.4142l-14.5-14.5c-0.39052-0.39052-1.0237-0.39052-1.4142 0s-0.39052 1.0237 0 1.4142l13.793 13.793-13.793 13.793z"
          fill="currentColor"
        />
      </svg>
    </button>
  );
};

interface CarouselProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
  settings?: Settings;
  children?: JSX.Element[];
  withMobileProgressBar?: boolean;
}

const Carousel: React.FC<CarouselProps> = props => {
  const { withMobileProgressBar, className, children, settings = {} } = props;
  const [currentSlide, setCurrentSlide] = useState(0);

  function afterChange(_currentSlide: number): void {
    setCurrentSlide(_currentSlide);
  }

  const settingsSlider = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    pauseOnHover: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    afterChange,
    ...settings,
  };

  return (
    <div className={cn(s.root, className)}>
      <SlickCarousel {...settingsSlider}>{children}</SlickCarousel>
      {withMobileProgressBar && (
        <ProgressBar
          currentSlide={currentSlide}
          count={Array.isArray(children) ? children.length : 0}
        />
      )}
    </div>
  );
};

export default Carousel;
